import { Container, Section } from 'components/GridV2';
import { GetKOHOBtn } from 'components/rebrand/GetKOHOBtn';
import { H1, P } from 'components/rebrand/Typography';

import { IQueryParams, ITrackEventProps } from 'typescriptDefs';
import { IHero } from 'typescriptDefs/pages/accounts';

type Props = {
  tracking: {
    queryParams: IQueryParams;
    trackEventProps: ITrackEventProps;
  };
} & IHero;

const Hero = ({ cta, heading, subheading, tracking, video }: Props) => {
  return (
    <Section className="py-40 md:pb-80 md:pt-96">
      <Container className="grid gap-32 px-32 xs:px-0 md:grid-cols-2">
        <div className="my-auto">
          <H1 className="mb-16 text-primary-400 md:mb-24 md:w-[80%]">{heading}</H1>
          <P className="mb-32 text-lg text-grey-300 md:mb-48 md:w-[85%] md:text-xl">{subheading}</P>
          <GetKOHOBtn
            buttonLocation="Accounts Hero"
            buttonSize="lg"
            queryParams={tracking.queryParams}
            trackEventProps={tracking.trackEventProps}
            className="block w-fit"
          >
            {cta.text}
          </GetKOHOBtn>
        </div>
        <div className="mx-auto w-fit overflow-hidden rounded-12 md:rounded-16">
          <video
            loop
            autoPlay
            playsInline
            webkit-playsinline="true"
            muted
            src={video.asset.url}
            className="aspect-[0.8] h-full max-h-500 object-cover object-center md:aspect-auto md:max-h-700 md:max-w-full"
          />
        </div>
      </Container>
    </Section>
  );
};

export default Hero;
